import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { detectMob, loadQueryString, numberWithCommas, toMillions, makeGET, makePOST } from "../../helpers/makeRequest";
import { conf } from '../../config/config'
import 'react-phone-number-input/style.css'
import moment from 'moment';
import $ from 'jquery'
import Spinner from 'react-bootstrap/Spinner';
import Select from "react-select";
import { createFilter } from "react-select";
import { Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto'
import gads from '../../imgs/google_ads.png'

$.DataTable = require('datatables.net')
require("datatables.net-responsive");

export const AdsScreen = () => {
    const user = useSelector((state) => state.auth);
    useEffect(() => {
        var x = new Date()

        var d = new Date(x.getFullYear(), x.getMonth() - 6, 1)
        x.setDate(0)
        var d1 = x
        let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
        strDate.setAttribute("value", moment(d).format("YYYY-MM-DD"))
        strDate.setAttribute("max", moment(d1).format("YYYY-MM-DD"))
        endDate.setAttribute("value", moment(d1).format("YYYY-MM-DD"))
        endDate.setAttribute("min", moment(d).format("YYYY-MM-DD"))

        getDatos();
    }, []);

    const hideEls = (key) => {
        var els = document.getElementsByClassName("hide" + key)
        for (var i = 0; i < els.length; i++) {
            els[i].style.display = "none"
            els[i].classList.remove("d-md-block")
            els[i].classList.remove("d-block")
        }
    }
    const [datos, setDatos] = useState([]);
    const [page, setPage] = useState([]);
    const [hostname, setHostname] = useState("");
    const [hostData, setHostData] = useState({ label: "TODOS", value: "TODOS" });
    const [dataSesiones, setDataSesiones] = useState(undefined);
    const [dataSesiones1, setDataSesiones1] = useState(undefined);
    const [dataFuentes, setDataFuentes] = useState(undefined);
    const [dataMedios, setDataMedios] = useState(undefined);
    const [dataDevices, setDataDevices] = useState(undefined);
    const [hostnames, setHostnames] = useState([])
    let options = {
        legend: { display: false },
        elements: {
            line: {
                tension: 0
            }
        },
        animation: false,
        scales: {
            y: {
                display: true,
                ticks: {
                    beginAtZero: true
                }
            }
        },
        maintainAspectRatio: false
    }
    let optionsFuentes = {
        animation: false,
    }

    let sesionesChart, sesionesChart1, fuentesChart, mediosChart, dispositivosChart
    let scrollTable

    const [conversionesTable, setConversionesTable] = useState(undefined)
    const [gruposTable, setGruposTable] = useState(undefined)
    const [terminosTable, setTerminosTable] = useState(undefined)
    const [topTable, setTopTable] = useState(undefined)

    const replace = (str, rep) => {
        return str.replace(/-/g, " ")
    }

    useEffect(() => {
        if (hostname != "") {
            getDatos()
        }
    }, [hostname])

    const returnPieData = (arr, x, y) => {
        let xValues = arr.slice(0, 4).map(v => v[x])
        let yValues = arr.slice(0, 4).map(v => v[y])
        if (arr.length > 4) {
            xValues = [...xValues, "Otros"]
            yValues = [...yValues.slice(0, 4), yValues.slice((yValues.length - (yValues.length - 4)), yValues.length).reduce((partialSum, a) => partialSum + a, 0)]
        }

        let tempArr = xValues.map((v, i) => {
            return {
                label: v,
                data: yValues[i] || 0
            }
        })

        tempArr.sort((a, b) => (a.data > b.data) ? 1 : ((b.data > a.data) ? -1 : 0))
        xValues = tempArr.map(v => v.label)
        yValues = tempArr.map(v => v.data)

        return { xValues, yValues }
    }

    const getDatos = async () => {
        let page = "", hostTmp = ((hostname != "" && hostname != "TODOS") ? hostname : "")
        const isMobile = detectMob()
        document.getElementById("loading").classList.remove("d-none")
        const params = loadQueryString();
        console.log(hostTmp)
        if (params.campaign) {
            hostTmp = params.campaign
            document.getElementById("hosts").style.display = "none"
        }

        const sampleUrl = "files_protected/sampleads.json"
        const url = "report/bqAds?" + "dateStr="
            + document.getElementById("strDate").value + "&dateEnd=" + document.getElementById("endDate").value
            + (hostTmp != "" ? "&campaign=" + hostTmp : "")

        let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
        strDate.setAttribute("max", endDate.value)
        endDate.setAttribute("min", strDate.value)

        let secs, formatted
        makeGET(params.test ? sampleUrl : url).then(({ data }) => {
            document.getElementById("loading").classList.add("d-none")
            secs = parseInt(data.tiempoTotal + "")
            formatted = moment.utc(secs * 1000).format('HH:mm:ss');

            $("#clics").text(toMillions(data.resumen.clics || 0))
            $("#impresiones").text(toMillions(data.resumen.impressions || 0))
            $("#impresion_top").text(((data.resumen.top_impression || 0) * 100).toFixed(2) + "%")
            $("#costo_clic").text("$" + parseFloat((data.resumen.cost || 0) / data.resumen.clics).toFixed(2))
            $("#llamadas").text(toMillions(data.resumen.llamadas || 0))
            $("#impresiones_tel").text(toMillions(data.resumen.imp_llamadas || 0))
            $("#ctr").text(parseFloat(data.resumen.ctr || 0).toFixed(2) + "%")

            setDataSesiones({
                labels: data.clics_periodo.map(v => v.fecha),
                datasets: [
                    {
                        label: "Clics",
                        type: "bar",
                        borderColor: "#385574",
                        backgroundColor: "#385574",
                        data: data.clics_periodo.map(v => v.clics),
                        fill: false
                    }
                ]
            })
            setDataSesiones1({
                labels: data.clics_hora.map(v => v.hora),
                datasets: [
                    {
                        label: "Llamadas",
                        type: "bar",
                        borderColor: "#ac1e75",
                        backgroundColor: "#ac1e75",
                        data: data.clics_hora.map(v => v.llamadas),
                        fill: false
                    }
                ]
            })

            let pieData = returnPieData(data.ubicaciones, "estado", "clics")

            setDataMedios({
                labels: pieData.xValues,
                datasets: [{
                    backgroundColor: ["#292b2c", "#56606b", "#ac1e75", "#58ac3f", "#0097a7"],
                    data: pieData.yValues
                }]
            })

            pieData = returnPieData(data.dispositivos, "dispositivo", "clics")

            setDataDevices({
                labels: pieData.xValues,
                datasets: [{
                    backgroundColor: ["#292b2c", "#56606b", "#ac1e75", "#58ac3f", "#0097a7"],
                    data: pieData.yValues
                }]
            })


            if (terminosTable) {
                terminosTable.clear()
                terminosTable.destroy()
            }

            data.terminos = data.terminos.map(v => {
                return {
                    ...v,
                    impresionesc: numberWithCommas(v.impresiones),
                    clicsc: numberWithCommas(v.clics),
                }
            })

            

            console.log(data.campaigns)
            setHostnames([{ label: "TODOS", value: "TODOS" }, ...data.campaigns.map(v => {
                return {
                    label: v.campaign_name, value: v.customer_id
                }
            })])

            setDatos({ ...data })
            setDateChanged(false)
        }).catch((e) => {
            document.getElementById("loading").classList.add("d-none")
            console.log(JSON.stringify(e))
        })
    };


    const tableRef = useRef()
    // console.log(tableRef)
    const tableName = "search"

    const [showOptions, setShowOptions] = useState(false);
    const handleInputChange = useCallback((typedOption) => {
        if (typedOption.length > 2) {
            setShowOptions(true);
        }
        else {
            setShowOptions(false);
        }
    }, []);

    const [dateChanged, setDateChanged] = useState(false)
    const submitDate = () => {
        let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
        strDate.setAttribute("max", endDate.value)
        endDate.setAttribute("min", strDate.value)
        setDateChanged(true)
    }
    return (
        <div className="">
            <div className="loading d-none text-center" id="loading">
                <div className="d-flex justify-content-center">
                    <p className="m-0"><Spinner animation="border" role="status" variant="dark"></Spinner></p>
                </div>
                <div className="d-flex justify-content-center">
                    <p style={{ color: "black", zIndex: 10001 }}>Cargando</p>
                </div>
            </div>
            <div id="firstRow" className="row p-3">
                <div className="col-12 col-md-4 pb-3 pt-3 pl-3 text-center">
                    <img width="60%" src={gads} />
                </div>
                <div className="col-12 col-md-4 pt-3">
                    <Select
                        options={(showOptions || hostnames < 1000) ? hostnames : []}
                        autoFocus={false}
                        className=""
                        id="hosts"
                        style={{ width: "100%", paddingTop: "1rem!important" }}
                        isSearchable={true}
                        noOptionsMessage={({ inputValue }) => "Escribe 2 o más letras para filtrar"}
                        onInputChange={handleInputChange}
                        filterOption={createFilter({ ignoreAccents: false })}
                        value={hostData}
                        onChange={(e) => {
                            setHostname(e.value)
                            setHostData(e)
                        }}
                    />
                </div>
                <div className="col-12 col-md-4">
                    <div className="row pt-0 pt-md-3 p-3">
                        <div className="input-group">
                            <input type="date" onChange={submitDate} id="strDate" className="form-control" />
                            <input type="date" onChange={submitDate} id="endDate" className="form-control" />
                            <button disabled={!dateChanged} onClick={getDatos} className="btn btn-primary">
                                <i className="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-4 text-center">
                    <p className="card-title font-weight-bold">Clics</p>
                    <h5 className="card-text" id="clics">-</h5>
                </div>
                <div className="col-md-3 col-4 text-center">
                    <p className="card-title font-weight-bold">Impresiones</p>
                    <h5 className="card-text" id="impresiones">-</h5>
                </div>
                <div className="col-md-3 col-4 text-center">
                    <p className="card-title font-weight-bold">Impresión (top) %</p>
                    <h5 className="card-text" id="impresion_top">-</h5>
                </div>
                <div className="col-md-3 col-4 text-center">
                    <p className="card-title font-weight-bold">Costo x clic</p>
                    <h5 className="card-text" id="costo_clic">-</h5>
                </div>
                <div className="col-4 text-center">
                    <p className="card-title font-weight-bold">Llamadas</p>
                    <h5 className="card-text" id="llamadas">-</h5>
                </div>
                <div className="col-4 text-center">
                    <p className="card-title font-weight-bold">Impresiones de teléfono</p>
                    <h5 className="card-text" id="impresiones_tel">-</h5>
                </div>
                <div className="col-md-4 col-12 text-center">
                    <p className="card-title font-weight-bold">CTR</p>
                    <h5 className="card-text" id="ctr">-</h5>
                </div>
                <br />
                <div className="col-md-6 col-12 mt-3 p-3">
                    {dataSesiones &&
                        <Bar options={options} data={dataSesiones} style={{ height: "250px" }} />
                    }
                </div>
                <div className="col-md-6 col-12 mt-3 p-3">
                    {dataSesiones1 &&
                        <Bar options={options} data={dataSesiones1} style={{ height: "250px" }} />
                    }
                </div>
                <div className="col-12 col-md-6 p-0 pl-2 pr-2 mb-3">
                    <div className="card w-100">
                        <div className="card-body text-center">
                            <h5 className="card-title font-weight-bold">Clics por dispositivo</h5>
                        </div>
                        <div className="row pl-3 pr-3">
                            {datos?.dispositivos &&
                                <>
                                    {datos?.dispositivos?.slice(0, 5).map((v, i) => (
                                        <>
                                            <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "left" }}>
                                                {v.dispositivo}
                                            </div>
                                            <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "center" }}>
                                                <h6>{numberWithCommas(v.clics)}</h6>
                                            </div>
                                        </>
                                    ))}
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 p-0 pl-2 pr-2 mb-3">
                    <div className="card w-100">
                        <div className="card-body text-center">
                            <h5 className="card-title font-weight-bold">Clics por ubicación geográfica</h5>
                        </div>
                        <div className="row pl-3 pr-3">
                            {datos?.ubicaciones &&
                                <>
                                    {datos?.ubicaciones?.slice(0, 5).map((v, i) => (
                                        <>
                                            <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "left" }}>
                                                {v.estado}
                                            </div>
                                            <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "center" }}>
                                                <h6>{numberWithCommas(v.clics)}</h6>
                                            </div>
                                        </>
                                    ))}
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 p-0 pl-2 pr-2 mb-3">
                    <div className="card w-100">
                        <div className="card-body text-center">
                            <h5 className="card-title font-weight-bold">Principales términos de búsqueda</h5>
                        </div>
                        <div className="row pl-3 pr-3">
                            {datos?.terminos &&
                                <>
                                    {datos?.terminos?.slice(0, 5).map((v, i) => (
                                        <>
                                            <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "left" }}>
                                                {v.search_term}
                                            </div>
                                            <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "center" }}>
                                                <h6>{numberWithCommas(v.impresiones)}</h6>
                                            </div>
                                        </>
                                    ))}
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 p-0 pl-2 pr-2 mb-3">
                    <div className="card w-100">
                        <div className="card-body text-center">
                            <h5 className="card-title font-weight-bold">Top palabras clave</h5>
                        </div>
                        <div className="row pl-3 pr-3">
                            {datos?.palabras_clave &&
                                <>
                                    {datos?.palabras_clave?.slice(0, 5).map((v, i) => (
                                        <>
                                            <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "left" }}>
                                                {v.keyword}
                                            </div>
                                            <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "center" }}>
                                                <h6>{numberWithCommas(v.impresiones)}</h6>
                                            </div>
                                        </>
                                    ))}
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
